import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbProductTabExtendedValidation } from '../../../models'

export const MB_PRODUCT_TAB_EXTENDED_VALIDATION_NORMALIZER = new InjectionToken<Converter<any, MbProductTabExtendedValidation>>('MbProductTabExtendedValidationNormalizer')
